import React, { useState } from 'react';
import useFetch from 'use-http';
import DirectLookup from 'src/components/common/DirectLookup';
import { ICompanyLookup, IInvoiceGroup } from 'src/models/dlcLease/IInvoiceGroup';
import InvoiceGroupModal from './InvoiceGroupModal';

const InvoiceGroupLookup: React.FC = () => {
    const { get: getInvoiceGroup, response: invoiceGroupResponse } = useFetch();
    const { get: getInvoiceGroupCompanies, response: invoiceGroupCompaniesResponse } = useFetch();
    const [invoiceGroupNumber, setInvoiceGroupNumber] = useState('');
    const [lookupError, setLookupError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [invoiceGroup, setInvoiceGroup] = useState<IInvoiceGroup | null>(null);
    const [companies, setCompanies] = useState<ICompanyLookup[]>([]);

    const handleLookup = async () => {
        const normalizedGroupNumber = invoiceGroupNumber.trim();
        if (!/^\d+$/.test(normalizedGroupNumber) || Number(normalizedGroupNumber) <= 0) {
            setLookupError('Enter a valid Invoice Group number.');
            return;
        }

        setIsLoading(true);
        setLookupError('');

        try {
            const groupData: IInvoiceGroup = await getInvoiceGroup(`/v1.0/leases/invoice-groups/${normalizedGroupNumber}`);
            if (!invoiceGroupResponse.ok || !groupData) {
                setLookupError(
                    invoiceGroupResponse.status === 404 || !groupData
                        ? 'Invoice Group not found.'
                        : 'Unable to load the Invoice Group. Please try again.'
                );
                return;
            }

            const companyData = await getInvoiceGroupCompanies('/v1.0/leases/master/companies');
            if (!invoiceGroupCompaniesResponse.ok || !Array.isArray(companyData)) {
                setLookupError('Invoice Group found, but company information could not be loaded. Please try again.');
                return;
            }

            setCompanies(
                companyData.map((company: Record<string, unknown>) => ({
                    compId: Number(company.id || company.compId),
                    name: String(company.name || ''),
                }))
            );
            setInvoiceGroup(groupData);
            setIsModalOpen(true);
        } catch {
            setLookupError('Unable to load the Invoice Group. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <DirectLookup
                value={invoiceGroupNumber}
                onValueChange={(value) => {
                    setInvoiceGroupNumber(value);
                    setLookupError('');
                }}
                onSubmit={handleLookup}
                placeholder="Invoice Group #"
                ariaLabel="Invoice Group number"
                buttonLabel="Open Group"
                loading={isLoading}
                error={lookupError}
                inputMode="numeric"
            />
            <InvoiceGroupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data={invoiceGroup} companies={companies} />
        </>
    );
};

export default InvoiceGroupLookup;



// WEBPACK FOOTER //
// ./src/components/leases/sections/InvoiceGroupLookup.tsx